import React, { useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import DetailView from "../../components/details/DetailView";
import {
  fetchPetFinderById,
  deletePetFinder,
  clearDetail as clearPetFinderDetail,
} from "../../redux/slices/petFinderSlice";

export default function PetFinderInfo() {
  const { id } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { detail: petFinder, detailStatus, error } = useSelector(
    (state) => state.petFinder
  );

  // Fetch Pet Finder by ID
  useEffect(() => {
    if (id) dispatch(fetchPetFinderById(id));
    return () => dispatch(clearPetFinderDetail());
  }, [dispatch, id]);

  if (detailStatus === "loading") return <div className="px-20 pt-10">Loading …</div>;
  if (detailStatus === "failed")
    return <div className="px-20 pt-10">Failed to load Pet Finder. {error}</div>;
  if (!petFinder) return <div className="px-20 pt-10">Pet not found.</div>;

  // Handlers
  const handleDelete = () => {
    dispatch(deletePetFinder(id));
    navigate(-1); // go back after deletion
  };

  const handleEdit = () => {
    navigate(`/swift-app/admin/pet-finder/${id}/edit`);
  };

  return (
    <DetailView
      title="Lost Pet Listing"
      type="pet-finder"
      data={petFinder}
      onDelete={handleDelete}
      onEdit={handleEdit}
    />
  );
}
